import React from 'react';
import {Text, View, StyleSheet } from '@react-pdf/renderer';
import { Fragment } from 'react';

const borderColor = '#90e5fc'
const styles = StyleSheet.create({
    row: {
        flexDirection: 'row',
        marginTop: 80,
        justifyContent: 'flex-end'
    },
    description: {
        width: 60
    },
    total: {
        width: '15%',
        textAlign: 'right',
        paddingRight: 8,
    },
  });


const InvoiceTableFooter = ({invoice}) => {
    return(    
        <Fragment>
            <View style={styles.row}>
                <Text style={styles.description}>TOTAL</Text>
                <Text>{invoice.amount}</Text>
            </View>
        </Fragment>
    )
};
  
  export default InvoiceTableFooter